import request from '@/utils/request'

/* 险种操作 */

// 获取列表
export function fetchList(query) {
  return request({
    url: `/insurance-type/types`,
    method: 'get',
    params: query
  })
}

export function fetchARList(typeid) {
  let query = {typeid: typeid}
  return request({
    url: '/insurance-type/ar-types',
    method: 'get',
    params: query
  })
}

// 创建
export function createInsuranceType(data) {
  return request({
    url: '/insurance-type/types',
    method: 'post',
    data
  })
}

// 根据id获取
export function fetchInsuranceType(id) {
  return request({
    url: '/insurance-type/type/' + id,
    method: 'get'
  })
}

// 更新
export function updateInsuranceType(id, data) {
  return request({
    url: '/insurance-type/type/' + id,
    method: 'patch',
    data
  })
}

export function fetchSchemeList(query) {
  return request({
    url: `/insurance-type/schemes`,
    method: 'get',
    params: query
  })
}

// 创建方案
export function createScheme(data) {
  return request({
    url: '/insurance-type/schemes',
    method: 'post',
    data
  })
}

// 根据id获取
export function fetchScheme(id) {
  return request({
    url: '/insurance-type/scheme/' + id,
    method: 'get'
  })
}

export function fetchDefaultScheme(typeid) {
  const query = {typeid: typeid}
  return request({
    url: '/insurance-type/default-scheme',
    method: 'get',
    params: query
  })
}

export function updateDefaultScheme(typeid, data) {
  const query = {typeid: typeid}
  return request({
    url: '/insurance-type/default-scheme',
    method: 'post',
    params: query,
    data
  })
}

export function updateScheme(id, data) {
  return request({
    url: '/insurance-type/scheme/' + id,
    method: 'patch',
    data
  })
}

// 删除险种方案
export function deleteScheme(id) {
  return request({
    url: '/insurance-type/scheme/' + id,
    method: 'delete'
  })
}

// 根据typeId获取条款列表
export function fetchClauseListByTypeId(typeId) {
  return request({
    url: '/insurance/type-clauses/' + typeId,
    method: 'get'
  })
}

export function createClause(typeId, data) {
  return request({
    url: '/insurance/type-clauses/' + typeId,
    method: 'post',
    data
  })
}

// 更新
export function updateClause(id, data) {
  return request({
    url: '/insurance/type-clause/' + id,
    method: 'patch',
    data
  })
}
